export type CoeffEnv = "development" | "staging" | "production";

declare const COEFF_ENV: CoeffEnv;

export const AssetsHost = () =>
  `https://coeff-image-store.s3.us-west-2.amazonaws.com/assets-${
    COEFF_ENV || process.env.NODE_ENV
  }`;

export const AlertAssetsHost = () =>
  `https://coeff-image-store.s3.us-west-2.amazonaws.com/alert-assets-${
    COEFF_ENV || process.env.NODE_ENV
  }`;
